import React from 'react';

function ArrowRight(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M13.0584 19.5455C12.8141 19.7894 12.8138 20.1852 13.0577 20.4294C13.3017 20.6737 13.6974 20.674 13.9416 20.43L21.5875 12.7948C22.0274 12.3555 22.0276 11.6427 21.588 11.2032L13.9419 3.55867C13.6978 3.31462 13.3021 3.31466 13.058 3.55877C12.814 3.80287 12.814 4.1986 13.0581 4.44265L19.9861 11.3691L2.60914 11.3691C2.26396 11.3691 1.98414 11.649 1.98414 11.9941C1.98414 12.3393 2.26396 12.6191 2.60914 12.6191L19.9945 12.6191L13.0584 19.5455Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowRight;
